var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetflix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 25,
    viewBox: "0 0 90 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.6446 12.3361L89.4384 24.9864C87.9736 24.7201 86.642 24.587 85.1772 24.3206L82.514 17.3962L79.7176 23.788C78.386 23.5217 77.0543 23.5217 75.7227 23.2553L80.5165 12.2029L76.1222 0.884155H80.1171L82.514 7.14276L85.3104 0.884155H89.4384L84.6446 12.3361ZM72.9263 0.884155H69.1978V22.7227C70.3963 22.7227 71.5947 22.7227 72.9263 22.989V0.884155ZM66.1351 22.4564C62.806 22.19 59.477 22.0569 56.0148 21.9237V0.884155H59.7433V18.4615C61.8739 18.4615 64.0045 18.7278 66.1351 18.7278V22.4564ZM52.0199 9.40651V13.135H46.8266V21.6574H43.0981V0.884155H53.6179V4.61268H46.8266V9.40651H52.0199ZM36.8395 4.61268V21.9237C35.641 21.9237 34.3094 21.9237 33.111 21.9237V4.61268H29.2493V0.884155H40.8343V4.61268H36.9727H36.8395ZM25.1213 13.4014C23.5233 13.4014 21.5259 13.4014 20.0611 13.4014V18.9942C22.3249 18.861 24.4554 18.7278 26.7192 18.5947V22.19L16.3326 22.989V0.884155H26.7192V4.61268H20.0611V9.67283C21.5259 9.67283 23.7896 9.67283 25.1213 9.67283V13.4014ZM4.34802 11.2708V24.3206C3.0164 24.4538 1.81795 24.587 0.486328 24.8533V0.884155H4.0817L9.00868 14.4667V0.884155H12.7372V23.3885C11.4056 23.6548 10.074 23.6548 8.6092 23.9211L4.34802 11.2708Z",
    fill: "#132A30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetflix);
export default __webpack_public_path__ + "static/media/netflix.d11949a5.svg";
export { ForwardRef as ReactComponent };